import React, { Component } from "react";
import { View, Text, Switch, StyleSheet } from "react-native";

import * as x from "../../styles/css";

class Checkbox extends Component {
	render() {
		return (
			<View style={[x.d.flex, x.flexDirection.row, x.alignItems.center]}>
				<Switch
					value={this.props.value}
					onValueChange={this.props.onValueChange}
					thumbTintColor={this.props.thumbTintColor}
					tintColor={this.props.tintColor}
					onTintColor={this.props.onTintColor}
				/>
				<Text style={[x.ml.two, x.fonts.text]}>{this.props.label}</Text>
			</View>
		);
	}
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js